// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__X-AX8","label":"Section_label__3Bl-4","contentWrap":"Section_contentWrap__10k1y","footer":"Section_footer__9o6KK","footerInner":"Section_footerInner__34emh"};